import { UserRole } from "@o2-fe/core";

// All available user roles from backend (matching UserRole enum)
// Organized by type: hierarchical roles first, then complementary roles
export const AVAILABLE_ROLES: UserRole[] = [
  // Hierarchical roles
  UserRole.ADMIN,
  UserRole.PROJECT_MANAGER,
  UserRole.SALES,
  UserRole.TEAM_LEAD,
  UserRole.ADMINISTRATION,
  UserRole.EMPLOYEE,
  UserRole.EXTERNAL_COLLABORATOR,
  // Complementary roles
  UserRole.APPROVER,
  UserRole.VALIDATOR,
];

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  // Hierarchical roles
  [UserRole.ADMIN]: "Amministratore",
  [UserRole.PROJECT_MANAGER]: "Project Manager",
  [UserRole.SALES]: "Vendite",
  [UserRole.TEAM_LEAD]: "Team Lead",
  [UserRole.ADMINISTRATION]: "Amministrazione",
  [UserRole.EMPLOYEE]: "Dipendente",
  [UserRole.EXTERNAL_COLLABORATOR]: "Collaboratore",
  // Complementary roles
  [UserRole.APPROVER]: "Timbratore",
  [UserRole.VALIDATOR]: "Validatore",
};
